"use strict";

module.exports = require("./Terminal");


//////////////////
// WEBPACK FOOTER
// ./~/spectacle-terminal/lib/index.js
// module id = 988
// module chunks = 32308089046778